/**
 * Converts a base64 encoded string to bytes array
 * @param base64Str base64 encoded string
 *
 * Note: atob funtion is not available in nodejs and is incorrectly marked as deprecated hence using window.btoa
 * For more info: https://github.com/microsoft/TypeScript/issues/45566 so the use of this function in a node app is
 * not recommended
 *
 * @returns bytes array
 */
const base64ToBytes = (base64Str) => {
    if (typeof window === 'undefined')
        return new Uint8Array();
    const binString = window.atob(base64Str);
    const bytes = binString.split('').map(char => char.charCodeAt(0));
    return new Uint8Array(bytes);
};
/**
 * Decodes a base64 encoded string. This function is meant to be executed on the front end only
 *
 * @param value base64 encoded string
 * @returns decoded string
 */
export const fromBase64 = (value) => new TextDecoder().decode(base64ToBytes(value));
/**
 * Converts a bytes array to base64 encoded string
 * @param bytes bytes array to be converted to base64
 *
 * Note: btoa funtions is not available in nodejs and is incorrectly marked as deprecated hence using window.btoa
 * For more info: https://github.com/microsoft/TypeScript/issues/45566 so the use of this function in a node app is
 * not recommended
 *
 * @returns base64 encoded string
 */
const bytesToBase64 = (bytes) => {
    if (typeof window === 'undefined')
        return '';
    const binString = Array.from(bytes, x => String.fromCodePoint(x)).join('');
    return window.btoa(binString);
};
/**
 * Encodes a string to base64 even with unicode characters. This function is meant to be executed on the front end only.
 *
 * @param value input string
 * @returns base64 encoded string
 */
export const toBase64 = (value) => bytesToBase64(new TextEncoder().encode(value));
//# sourceMappingURL=base64.js.map